var _excluded = ["content", "aside", "footerContent"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import ParentHorizontalPaddingSpaceContext from "../../../contexts/ParentHorizontalPaddingSpaceContext";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { Container, Wrapper } from "./AxContainerOrg.styled";
export var horizontalPaddingSpaceOnSmallOnly = 2;
export var horizontalPaddingSpaceOnMediumUp = 5;
export var contentBackground = "backgroundLight";
export var asideBackground = "background";
var AXContainerOrg = function AXContainerOrg(_ref) {
  var content = _ref.content,
    aside = _ref.aside,
    footerContent = _ref.footerContent,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isSmallOnly = useBreakpoint("small", "medium");
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, restProps, {
    $hasAside: !!aside
  }), content ? /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: contentBackground
  }, /*#__PURE__*/React.createElement(ParentHorizontalPaddingSpaceContext.Provider, {
    value: isSmallOnly ? horizontalPaddingSpaceOnSmallOnly : horizontalPaddingSpaceOnMediumUp
  }, content, footerContent))) : null, !!aside && /*#__PURE__*/React.createElement(Container, {
    $isAside: true
  }, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: asideBackground
  }, /*#__PURE__*/React.createElement(ParentHorizontalPaddingSpaceContext.Provider, {
    value: isSmallOnly ? horizontalPaddingSpaceOnSmallOnly : horizontalPaddingSpaceOnMediumUp
  }, aside))));
};
export default AXContainerOrg;